import { useState } from 'react';

interface TruncatedTextProps {
  text: string;
  maxLength?: number;
  className?: string;
  style?: React.CSSProperties;
}

export function TruncatedText({
  text,
  maxLength = 50,
  className = '',
  style,
}: TruncatedTextProps) {
  const [showTooltip, setShowTooltip] = useState(false);
  const shouldTruncate = text.length > maxLength;

  return (
    <div className="relative inline-block max-w-full">
      <span
        className={`${className} ${shouldTruncate ? 'truncate block' : ''}`}
        onMouseEnter={() => shouldTruncate && setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        style={style}
      >
        {text}
      </span>
      {showTooltip && shouldTruncate && (
        <div className="absolute z-50 px-3 py-2 bg-gray-900 text-white text-xs rounded-md shadow-lg -top-10 left-0 whitespace-nowrap max-w-xs">
          {text}
        </div>
      )}
    </div>
  );
}
